import React, { useState, useEffect } from 'react';
import { BringzzButton, BringzzText } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import {
    BringzzPageContainer,
    BringzzIcon,
} from "@bringzz/components";
import { useParams } from 'react-router-dom';
import EditCardForm from './EditCardForm';
import { toast } from 'react-toastify';

// Mock data - in real app this would come from an API
const MOCK_PAYMENT_METHODS = [
    {
        id: 1,
        type: 'credit_card',
        last4: '4242',
        expiryDate: '12/24',
        brand: 'Visa',
        cardNumber: '4242424242424242',
        cardHolder: 'John Doe',
        cvc: '123'
    },
    {
        id: 2,
        type: 'sofort',
        bankName: 'Deutsche Bank'
    }
];

const EditPaymentMethod = () => {
    const { backPress, navigate } = useNavigation();
    const { id } = useParams();
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Simulate API call to fetch payment method details
        const fetchPaymentMethod = async () => {
            try {
                // In real app, this would be an API call
                const method = MOCK_PAYMENT_METHODS.find(m => m.id === parseInt(id));
                if (!method) {
                    toast.error('Payment method not found');
                    navigate('/payment');
                    return;
                }
                setPaymentMethod(method);
            } catch (error) {
                console.error('Failed to fetch payment method:', error);
                toast.error('Failed to load payment method details');
                navigate('/payment');
            } finally {
                setLoading(false);
            }
        };

        fetchPaymentMethod();
    }, [id, navigate]);

    const handleSubmit = async (formData) => {
        try {
            // Simulate API call
            await new Promise(resolve => setTimeout(resolve, 1000));
            
            // Update local state
            const updatedMethod = {
                ...paymentMethod,
                ...formData
            };
            setPaymentMethod(updatedMethod);
            
            toast.success('Payment method updated successfully');
            navigate('/payment');
        } catch (error) {
            console.error('Failed to update payment method:', error);
            toast.error('Failed to update payment method');
        }
    };

    if (loading) {
        return (
            <BringzzPageContainer
                className="bg-white"
                header={{
                    left: (
                        <BringzzIcon
                            size='22'
                            icon='IconChevronLeft'
                            folder='LineIcons'
                            className='cursor-pointer'
                            onClick={backPress}
                        />
                    ),
                    title: <BringzzText tag='h2'>Edit Credit Card</BringzzText>
                }}
            >
                <div className="flex justify-center items-center h-full">
                    <BringzzText tag='p'>Loading...</BringzzText>
                </div>
            </BringzzPageContainer>
        );
    }

    if (!paymentMethod) {
        return null;
    }

    // Render different forms based on payment method type
    const renderEditForm = () => {
        switch (paymentMethod.type) {
            case 'credit_card':
                return (
                    <EditCardForm
                        initialValues={{
                            cardNumber: paymentMethod.cardNumber,
                            cardHolder: paymentMethod.cardHolder,
                            expiryDate: paymentMethod.expiryDate,
                            cvc: paymentMethod.cvc
                        }}
                        onSubmit={handleSubmit}
                        submitButtonText="Save Changes"
                    />
                );
            case 'sofort':
                return (
                    <div className="p-6 text-center">
                        <BringzzText tag='p'>Sofort payment method editing coming soon</BringzzText>
                    </div>
                );
            default:
                return (
                    <div className="p-6 text-center">
                        <BringzzText tag='p'>Editing not supported for this payment method</BringzzText>
                    </div>
                );
        }
    };

    return (
        <BringzzPageContainer
            className="bg-white"
            header={{
                left: (
                    <BringzzIcon
                        size='22'
                        icon='IconChevronLeft'
                        folder='LineIcons'
                        className='cursor-pointer'
                        onClick={backPress}
                    />
                ),
                title: <BringzzText tag='h2'>Edit Credit Card</BringzzText>
            }}
        >
            {renderEditForm()}
        </BringzzPageContainer>
    );
};

export default EditPaymentMethod; 